import BreadcrumbsListView from "../view/list.js";
import BreadcrumbsItemView from "../view/item.js";

import ScrollContainer from "../../scroll-container/scroll-container.js";

import {
  debounce
} from "../../../utils/debounce.js";

export default class Breadcrumbs {
  constructor(element) {
    this._element = element;

    this._scrollContainer = new ScrollContainer();

    this._listView = null;
    this._itemsViews = [];

    this._handleWindowLoad = this._handleWindowLoad.bind(this);
    this._handleWindowResize = this._handleWindowResize.bind(this);
  }

  init() {
    this._listView = new BreadcrumbsListView(this._element);

    Array.from(this._listView.getItems())
      .forEach((item) => {
        const view = new BreadcrumbsItemView(item);
        this._itemsViews.push(view);
      });

    window.addEventListener(`load`, this._handleWindowLoad);
    window.addEventListener(`resize`, debounce(this._handleWindowResize));
  }

  _scrollList() {
    const itemsFullWidth = this._itemsViews
      .slice()
      .map((view) => {
        return view.getFullWidth();
      })
      .reduce((previousValue, currentValue) => {
        return previousValue + currentValue;
      }, 0);

    const listInnerWidth = this._listView.getInnerWidth();

    if (listInnerWidth < itemsFullWidth) {
      this._scrollContainer.scroll({
        element: this._listView.getElement(),
        offsetLeft: itemsFullWidth
      });
    }
  }

  _handleWindowLoad() {
    this._scrollList();
  }

  _handleWindowResize() {
    this._scrollList();
  }
}
